import { Injectable } from '@angular/core'
import { HttpService, LibEntry, Organization } from '@surgetech-eu/core'
import { Observable } from 'rxjs'
import { Certificate } from '../certification/service/certification.service'

export interface PlatingMaterial {
    id?: string
    new?: boolean
    organizationId?: string
    organization?: Organization
    vendorCode: string
    vendorDescription: string
    vendorMaterialFamily?: LibEntry
    materialFamily?: LibEntry
    material?: LibEntry
    rawMaterialProvenance?: LibEntry
    countryOfOrigin?: LibEntry
    karats?: number
    saltSupplier?: LibEntry
    certificationTypes?: LibEntry[]
    validationStatus?: string
    rejectionReason?: string
    certification?: boolean
    uploadedCertifications?: Certificate[]
    isAllCertificationsUploaded?: boolean
    missingMandatoryCertifications?: LibEntry[]
    // only for front end
    supplier?: LibEntry
}

@Injectable()
export class PlatingMaterialService {
    private baseUrl = '/component-mapping/plating-materials'

    constructor(private http: HttpService) {
        //
    }

    public getAll(organizationId?: string, criteria?: Map<string, any>): Observable<PlatingMaterial[]> {
        const q = new URLSearchParams()
        ;(criteria || new Map()).forEach((v, k) => {
            q.append(k, v)
        })

        const url = this.baseUrl + (organizationId ? '/' + organizationId : '')
        return this.http.get(url + '?' + q.toString())
    }

    public createPlatingMaterials(data: PlatingMaterial[]): Observable<unknown> {
        return this.http.post(this.baseUrl, { data })
    }

    public updatePlatingMaterials(data: PlatingMaterial[]): Observable<unknown> {
        return this.http.put(this.baseUrl, { data })
    }
}
